import React from 'react';

import AutoLogin from '@Components/login/autoLogin';

const AutoLoginPage = props => (
  <AutoLogin {...props} />
);

export default AutoLoginPage;